import * as React from 'react';

import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { Sidebar } from '~/components/Sidebar';
import { SidebarMenu } from '~/components/Sidebar/SidebarMenu';
import { SidebarLayout } from '~/scenes/PortalViews/components/SidebarLayout';
import { StructuredModuleRouter } from '~/scenes/PortalViews/components/StructuredModuleRouter';
import { useAnalyticsViews } from '~/scenes/PortalViews/Views/AnalyticsViews/useAnalyticsViews';

export const AnalyticsViews = () => {
  const { navigationPaths, routingStructure } = useAnalyticsViews();

  return (
    <SidebarLayout
      sidebar={
        <Sidebar scrollContent={true}>
          <SidebarMenu
            navigationRootPath={'/portal/analytics'}
            levelPaths={navigationPaths}
          />
        </Sidebar>
      }
    >
      <PortalErrorBoundary>
        <StructuredModuleRouter routingStructure={routingStructure} />
      </PortalErrorBoundary>
    </SidebarLayout>
  );
};
